import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import getters from "./getters";
import menu from "./modules/menu.js";
import websiteConfig from "./modules/websiteConfig.js"; // 网站配置相关

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    menu,
    websiteConfig
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js